//#region DevExtreme Imports

import DevExpress from 'devextreme'
import DataSource from 'devextreme/data/data_source'
import ArrayStore from 'devextreme/data/array_store'

//#endregion

import { OperatorLayoutSettings } from '../../../helpers/operator-layout-settings'
import { i18n } from '../i18n/common.i18n'
import { EventsNames } from '../../../helpers/events-names'
import { IMRBaseControlDirectiveController } from '../base'


export interface SaveColumnSettingsScope extends ng.IScope {
    isSaveColumnSettingPopoverVisible: boolean
    isSaveColumnSettingPopupVisible: boolean
    saveColumnSettingPopover: DevExpress.ui.dxPopover
    saveColumnSettingPopoverOptions: DevExpress.ui.dxPopoverOptions
    saveColumnSettingPopup: DevExpress.ui.dxPopup
    saveColumnSettingPopupOptions: DevExpress.ui.dxPopupOptions
    saveColumnSettingForm: DevExpress.ui.dxForm
    saveColumnSettingFormOptions: DevExpress.ui.dxFormOptions
    loadColumnSettingForm: DevExpress.ui.dxForm
    loadColumnSettingFormOptions: DevExpress.ui.dxFormOptions
    saveColumnSettingData: any
    loadColumnSettingData: any
    saveColumnSettingButtonOptions: DevExpress.ui.dxButtonOptions
    loadColumnSettingButtonOptions: DevExpress.ui.dxButtonOptions
    deleteColumnSettingButtonOptions: DevExpress.ui.dxButtonOptions
    saveColumnSettingFormItems: any[]
    loadColumnSettingFormItems: any[]
    submitSaveColumnSettingOptions: DevExpress.ui.dxButtonOptions
    submitLoadColumnSettingOptions: DevExpress.ui.dxButtonOptions
    submitDeleteColumnSettingOptions: DevExpress.ui.dxButtonOptions
    loadColumnSettingFormSelectBoxItemsOptions: DevExpress.data.DataSourceOptions
    selectBoxOptions: DevExpress.ui.dxSelectBoxOptions
    selectBoxInstance: DevExpress.ui.dxSelectBox
    textBoxInstance: DevExpress.ui.dxTextBox
    selectBoxValue: string
    gridName: string
    gridId: string
    submitLoadColumnSettingButtonDisabled: boolean
    submitDeleteColumnSettingButtonDisabled: boolean
    submitSaveColumnSettingButtonDisabled: boolean
    needConfirmDelete: boolean
    deleteTitle: string
    confirmDelete()
    needConfirmUpdate: boolean
    updateTitle: string
    saveOrUpdate()
}

export class SaveColumnSettingsController extends IMRBaseControlDirectiveController {
    private selectBox: DevExpress.ui.dxSelectBox

    constructor(private $scope: SaveColumnSettingsScope, private $timeout: ng.ITimeoutService) {
        super()
        
        $scope.deleteTitle = i18n('Popup', 'ElementDeleting')
        $scope.updateTitle = i18n('Popup', 'ElementUpdating')
        if (!$scope.gridId) $scope.gridId = ''

        this.setSaveColumnSettingOptions()
        this.setLoadColumnSettingOptions()

        $scope.submitSaveColumnSettingButtonDisabled = true
        $scope.submitLoadColumnSettingButtonDisabled = true
        if (OperatorLayoutSettings.getSetting('LAST_SET_COLUMN_SETTINGS_' + this.$scope.gridName, null) !== 'default') {
            $scope.submitDeleteColumnSettingButtonDisabled = false
        } else {
            $scope.submitDeleteColumnSettingButtonDisabled = true
        }

        $scope.isSaveColumnSettingPopoverVisible = false
        $scope.isSaveColumnSettingPopupVisible = false

        this.loadLastColumnSettings()

        $scope.saveColumnSettingPopoverOptions = {
            width: 400,
            height: 300,
            target: '#saveColumnSettingsButton' + $scope.gridId,
            showTitle: true,
            title: i18n("Grid", "ColumnConfiguration"),
            bindingOptions: {
                visible: 'isSaveColumnSettingPopoverVisible'
            },
            onHidden: () => {
                $scope.isSaveColumnSettingPopoverVisible = false
            },
            onShowing: () => {
                $scope.isSaveColumnSettingPopoverVisible = true
            },
            onInitialized: (e) => {
                $scope.saveColumnSettingPopover = e.component
            }
        }

        $scope.saveColumnSettingPopupOptions = {
            width: 400,
            height: 300,
            showTitle: true,
            title: i18n("Grid", "ColumnConfiguration"),
            bindingOptions: {
                visible: 'isSaveColumnSettingPopupVisible'
            },
            onHidden: () => {
                $scope.isSaveColumnSettingPopupVisible = false
            },
            onShowing: () => {
                $scope.isSaveColumnSettingPopupVisible = true
            },
            onInitialized: (e) => {
                $scope.saveColumnSettingPopup = e.component
            }
        }

        $scope.$on(EventsNames.SHOW_SAVE_COLUMN_SETTINGS + $scope.gridId, (event, args) => {
            if (args) {
                $scope.isSaveColumnSettingPopupVisible = false
                if ($scope.isSaveColumnSettingPopoverVisible == true) {
                    $scope.isSaveColumnSettingPopoverVisible = false
                    $scope.saveColumnSettingPopover.hide()
                    $('.dx-button').blur()
                } else if ($scope.isSaveColumnSettingPopoverVisible == false) {
                    $scope.isSaveColumnSettingPopoverVisible = true
                    $scope.saveColumnSettingPopover.show()
                }
            } else {
                $scope.isSaveColumnSettingPopoverVisible = false
                if ($scope.isSaveColumnSettingPopupVisible == true) {
                    $scope.isSaveColumnSettingPopupVisible = false
                    $scope.saveColumnSettingPopup.hide()
                    $('.dx-button').blur()
                } else if ($scope.isSaveColumnSettingPopupVisible == false) {
                    $scope.isSaveColumnSettingPopupVisible = true
                    $scope.saveColumnSettingPopup.show()
                }
            }
        })

        $scope.submitDeleteColumnSettingOptions = {
            text: i18n("Grid", "Delete"),
            bindingOptions: {
                disabled: 'submitDeleteColumnSettingButtonDisabled'
            },
            onClick: () => {
                $scope.needConfirmDelete = true
                $timeout(() => {
                    $scope.$broadcast(EventsNames.OPEN_CONFIRMATION_POPUP + this.$scope.gridId, i18n('Popup', 'ConfirmDeleteSaveColumnSetting'))
                })
            }
        }

        $scope.confirmDelete = () => {
            this.deleteLoadColumnSettingFormSelectBoxItems()
            var lastColumnSettingName = OperatorLayoutSettings.getSetting('LAST_SET_COLUMN_SETTINGS_' + this.$scope.gridName, null)
            if (lastColumnSettingName === null)
                $scope.loadColumnSettingForm.resetValues()
            else
                $scope.selectBoxValue = lastColumnSettingName

            if (this.$scope.isSaveColumnSettingPopoverVisible == true) this.$scope.saveColumnSettingPopover.hide()
            if (this.$scope.isSaveColumnSettingPopupVisible == true) this.$scope.saveColumnSettingPopup.hide()
            $scope.needConfirmDelete = false
        }

        this.$scope.submitSaveColumnSettingOptions = {
            text: i18n("Grid", "Save"),
            bindingOptions: {
                disabled: 'submitSaveColumnSettingButtonDisabled'
            },
            onClick: () => {
                if (this.checkIfUpdate() === true) {
                    $scope.needConfirmUpdate = true
                    $timeout(() => {
                        $scope.$broadcast(EventsNames.OPEN_CONFIRMATION_POPUP + this.$scope.gridId, i18n('Popup', 'ConfirmUpdateSaveColumnSetting'))
                    })
                }
                else {
                    $scope.saveOrUpdate()
                }
            }
        }

        $scope.saveOrUpdate = () => {
            this.saveColumnSetting();
            this.$scope.saveColumnSettingForm.resetValues()
            $scope.needConfirmUpdate = false
        }
    }

    updateDataSourceForSelectBox(component: DevExpress.ui.dxSelectBox) {
        if (component) {
            var items = [<any>{
                default: true,
                Key: "default",
                Name: i18n("Popup", "DefaultConfiguration")
            }]

            var settingArray = OperatorLayoutSettings.getSetting('GRID_COLUMNS_SETTING_ARRAY_' + this.$scope.gridName, null);

            if (settingArray !== null) {
                angular.forEach(settingArray, (obj, key) => {
                    items.push({
                        Key: key,
                        Name: (key as any as string).replace("SAVED_", "")
                    })
                })
            }

            var dataSourceOptions = {
                store: new ArrayStore({data: items})
            }
            var dataSource = new DataSource(dataSourceOptions)
            this.$scope.selectBoxOptions.dataSource = dataSource

            if (items.map(i => i.Key).indexOf(this.$scope.selectBoxValue) < 0) {
                this.$scope.selectBoxValue = items[items.length - 1].Key
            }

            component.option({
                dataSource: dataSource,
                value: this.$scope.selectBoxValue
            })
        }
    }

    setLoadColumnSettingOptions() {
        this.$scope.selectBoxOptions = {
            placeholder: i18n("Grid", "Select") + '...',
            dataSource: [],
            valueExpr: 'Key',
            displayExpr: 'Name',
            searchEnabled: true,
            noDataText: i18n("Grid", "NoSavedConfiguration"),
            onInitialized: e => {
                this.selectBox = e.component
                this.$timeout(() => {
                    this.updateDataSourceForSelectBox(this.selectBox)
                })
            },
            onValueChanged: (e) => {
                if (e.value && e.value.length > 0) {
                    this.$scope.submitLoadColumnSettingButtonDisabled = false
                    if (e.value == "default") {
                        this.$scope.submitDeleteColumnSettingButtonDisabled = true
                    } else {
                        this.$scope.submitDeleteColumnSettingButtonDisabled = false
                    }
                }
            }
        }

        this.$scope.loadColumnSettingFormItems = [
            {
                dataField: 'load',
                label: {
                    text: i18n('Grid', 'Load')
                },
                visible: true,
                editorType: 'dxSelectBox',
                editorOptions: this.$scope.selectBoxOptions,
            }
        ]

        this.$scope.loadColumnSettingFormOptions = {
            colCount: 1,
            height: '50%',
            labelLocation: 'top',
            items: this.$scope.loadColumnSettingFormItems,
            onInitialized: e => {
                this.$scope.loadColumnSettingForm = e.component
            }
        }

        this.$scope.submitLoadColumnSettingOptions = {
            text: i18n("Grid", "Load"),
            bindingOptions: {
                disabled: 'submitLoadColumnSettingButtonDisabled'
            },
            onClick: () => {
                this.loadColumnSetting(null)
                if (this.$scope.isSaveColumnSettingPopoverVisible == true)
                    this.$scope.saveColumnSettingPopover.hide()
                if (this.$scope.isSaveColumnSettingPopupVisible == true)
                    this.$scope.saveColumnSettingPopup.hide()
            }
        }
    }

    setSaveColumnSettingOptions() {
        this.$scope.saveColumnSettingFormItems = [
            {
                dataField: 'save',
                label: {
                    text: i18n('Popup', 'Name'),
                },
                visible: true,
                editorType: 'dxTextBox',
                editorOptions: {
                    showClearButton: true,
                    valueChangeEvent: "keyup",
                    onValueChanged: (e) => {
                        if (e.value && e.value.length > 0) {
                            this.$scope.submitSaveColumnSettingButtonDisabled = false
                        }
                        else {
                            this.$scope.submitSaveColumnSettingButtonDisabled = true
                        }
                    }
                }
            }
        ]

        this.$scope.saveColumnSettingFormOptions = {
            colCount: 1,
            height: '50%',
            labelLocation: 'top',
            items: this.$scope.saveColumnSettingFormItems,
            onInitialized: e => {
                this.$scope.saveColumnSettingForm = e.component
                this.$scope.textBoxInstance = (e as any).model.saveColumnSettingFormItems[0]
            }
        }
    }

    saveColumnSetting() {
        var form = this.$scope.saveColumnSettingForm.option('formData')
        var columnSettings: any = OperatorLayoutSettings.getSetting('SAVED_TABLE_' + this.$scope.gridName, null);
        var settingArray = OperatorLayoutSettings.getSetting('GRID_COLUMNS_SETTING_ARRAY_' + this.$scope.gridName, null);
        if (settingArray === null) {
            settingArray = {};
        }
        
        settingArray["SAVED_" + form.save] = [columnSettings.columns]
        OperatorLayoutSettings.setSetting('GRID_COLUMNS_SETTING_ARRAY_' + this.$scope.gridName, settingArray);
        var formLoad = this.$scope.loadColumnSettingForm.option('formData');

        this.$scope.selectBoxValue = form.save
        this.updateDataSourceForSelectBox(this.selectBox)

        OperatorLayoutSettings.setSetting('LAST_SET_COLUMN_SETTINGS_' + this.$scope.gridName, form.save);
    }

    deleteLoadColumnSettingFormSelectBoxItems() {
        var form = this.$scope.loadColumnSettingForm.option('formData')
        var settingArray = OperatorLayoutSettings.getSetting('GRID_COLUMNS_SETTING_ARRAY_' + this.$scope.gridName, null)
        delete settingArray[form.load]
        OperatorLayoutSettings.setSetting('GRID_COLUMNS_SETTING_ARRAY_' + this.$scope.gridName, settingArray)

        this.updateDataSourceForSelectBox(this.selectBox)

        if (OperatorLayoutSettings.getSetting('LAST_SET_COLUMN_SETTINGS_' + this.$scope.gridName, null) == form.load) {
            OperatorLayoutSettings.setSetting('LAST_SET_COLUMN_SETTINGS_' + this.$scope.gridName, 'default')
            this.loadColumnSetting('default')
        }
    }

    loadColumnSetting(settingName: any) {
        var setColumns = []
        if (settingName === null) {
            var form = this.$scope.loadColumnSettingForm.option('formData')
            settingName = form.load
        }
        var settingArray = OperatorLayoutSettings.getSetting('GRID_COLUMNS_SETTING_ARRAY_' + this.$scope.gridName, null)
        var columnSettings: any = OperatorLayoutSettings.getSetting('SAVED_TABLE_' + this.$scope.gridName, null);
        if (settingArray === null) {
            settingName = 'default'
        }
        if (settingName != "default") {
            if (columnSettings) {
                var savedColumns: any[] = columnSettings.columns
                if (savedColumns && Array.isArray(savedColumns)) {
                    savedColumns.forEach(column => {
                        settingArray[settingName][0].forEach(saColumn => {
                            if (column.dataField == saColumn.dataField) {
                                column = saColumn
                            }
                        })
                        setColumns.push(column)
                    })
                }
            }
            columnSettings.columns = setColumns
        }
        else {
            columnSettings.columns = false
        }
        OperatorLayoutSettings.setSetting('SAVED_TABLE_' + this.$scope.gridName, columnSettings)
        OperatorLayoutSettings.setSetting('LAST_SET_COLUMN_SETTINGS_' + this.$scope.gridName, settingName);
        this.$scope.$root.$broadcast(EventsNames.LOAD_COLUMN_SETTINGS + this.$scope.gridId)
    }

    loadLastColumnSettings() {
        var lastColumnSettingName: string
        lastColumnSettingName = OperatorLayoutSettings.getSetting('LAST_SET_COLUMN_SETTINGS_' + this.$scope.gridName, null)
        this.$scope.selectBoxValue = lastColumnSettingName
    }

    checkIfUpdate() {
        var ifUpdate: boolean
        ifUpdate = false
        var newConfigName = this.$scope.saveColumnSettingForm.option('formData').save
        var settingArray = OperatorLayoutSettings.getSetting('GRID_COLUMNS_SETTING_ARRAY_' + this.$scope.gridName, null)
        angular.forEach(settingArray, function (value, key) {
            if (key == newConfigName)
                ifUpdate = true
        })
        return ifUpdate
    }
}